import { useQuery } from '@tanstack/react-query';
import dataService from 'services/dataService';
import { showResult } from 'infrastructure/hooks/utils';
import { apiUrlGenerator } from 'infrastructure/hooks/use-api';

interface Props {
  conversationId: number | string;
  enabled?: boolean;
}

export const getSmsDashboardScheduledMessagesFn = async (props: Props) => {
  const url = (id: string) => `core-2/conversations/${id}/scheduled-messages`;

  const { data, error } = await dataService.getList(
    apiUrlGenerator(url(String(props.conversationId))),
  );

  if (error) {
    showResult('Unable to retrieve scheduled messages');
    throw new Error(error);
  }

  return data;
};

export const getSmsDashboardScheduledMessagesKey = (props: Props) => {
  const copy = structuredClone(props);
  return ['getSmsDashboardScheduledMessages', copy];
};

export const useScheduledMessages = ({ enabled = true, ...props }: Props) => {
  const {
    data: scheduledMessages,
    refetch,
    isFetching,
    isLoading,
    isRefetching,
    ...other
  } = useQuery({
    queryKey: getSmsDashboardScheduledMessagesKey(props),
    queryFn: async () => {
      return getSmsDashboardScheduledMessagesFn({
        ...props,
      });
    },
    enabled,
  });

  return {
    scheduledMessages,
    fetchScheduledMessages: refetch,
    scheduledMessagesLoading: isLoading || isFetching || isRefetching,
    isLoading,
    isFetching,
    ...other,
  };
};
